import { Box, Text } from "@chakra-ui/react";
import { Controller } from "react-hook-form";
import AsyncSelect from "react-select/async";
import AttachmentBar from "../../../components/AttachmentBar";
import { Input } from "../../../components/common";
import AttachmentViewer from "../../../components/common/AttachmentViewer";
import { useUserInfo } from "../../../utils/hooks/useUserInfo";
import { loadOutboundLine } from "../bdc-campaign/CreateCampaign/utils";
import DebouncedAsyncSelect from "../../../components/common/DebouncedAsyncSelect";

export default function SmsContent({
  control,
  setValue,
  getValues,
  attachmentUrls,
  setAttachmentUrls,
}: any) {
  const dId = useUserInfo("dealership")?.id;
  return (
    <>
      <Box mb="1rem">
        <Text textStyle="h5" mb="0.62rem">
          Line<span style={{ color: "red" }}>*</span>
        </Text>
        <Controller
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            return (
              <DebouncedAsyncSelect
                loadOptions={(searchStr) => loadOutboundLine(searchStr, dId)}
                defaultOptions
                value={value}
                onChange={(val: string) => onChange(val)}
                placeholder="Select line"
                styles={{
                  control: (provided: any) => ({
                    ...provided,
                    maxWidth: "100%",
                    marginBottom: "0.5rem",
                  }),
                }}
              />
            );
          }}
          name="line_id"
          control={control}
          rules={{
            required: true,
          }}
        />
      </Box>
      <Box mb="1rem">
        <Controller
          name="content"
          control={control}
          render={({ field, fieldState: { error } }) => {
            return (
              <Input
                placeholder="Type sms here"
                hasIcon={false}
                label="Message"
                type="text"
                maxW="lg"
                w="100%"
                isTextarea={true}
                rows={5}
                {...field}
                error={error?.message}
                isRequired
                showCharCount
                isTranslatable
                top="15%"
              />
            );
          }}
        />
        <Box mt="1rem">
          <AttachmentBar
            gap="0.5rem"
            width="3rem"
            flexWrap="wrap"
            setBody={(text, concatText, type = "text") => {
              if (type === "text") {
                const content = `${concatText ? `${concatText}: ` : ""}${text}`;
                const messagesText = getValues("content")
                  ? `${getValues("content")} ${content}`
                  : `${content}`;
                setValue("content", messagesText);
              } else {
                setAttachmentUrls((prev: any) => [...prev, text]);
              }
            }}
            handleTemplate={(value, body = "", attachmentUrls) => {
              setValue("content", body);
              setAttachmentUrls(attachmentUrls);
            }}
          />
          <AttachmentViewer
            attachments={attachmentUrls}
            setAttachments={setAttachmentUrls}
          />
        </Box>
      </Box>
    </>
  );
}
